import { Search } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { buttonVariants } from '~/components/ui/button'
import { useUserContext } from '~/providers/user-provider'

export const FindCocoonFloatingBtn = () => {
	const { t } = useTranslation()
	const { userQuery } = useUserContext()

	return (
		<Link
			href={`/${userQuery.data?.default_zone || 'paris'}`}
			className={buttonVariants({
				variant: 'gradient',
				className:
					'-translate-x-1/2 fixed bottom-6 left-1/2 z-30 whitespace-nowrap px-8 font-semibold text-base shadow-[0px_0px_15px_0px_#EDEDED] md:hidden',
			})}
		>
			<Search
				size={16}
				className='mr-2'
			/>

			{t('cwNavbar:findCocoon')}
		</Link>
	)
}
